import { render, staticRenderFns } from "./SubGalleryNav.vue?vue&type=template&id=0f12601e&scoped=true&"
import script from "./SubGalleryNav.vue?vue&type=script&lang=js&"
export * from "./SubGalleryNav.vue?vue&type=script&lang=js&"
import style0 from "./SubGalleryNav.vue?vue&type=style&index=0&id=0f12601e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12601e",
  null
  
)

export default component.exports